import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQProps {
  question: string;
  answer: string;
}
export function FAQ({
  question,
  answer
}: FAQProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm" data-id="element-10">
      <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-11">
        <span className="font-semibold text-lg text-dark" data-id="element-12">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-13">
          <ChevronDown className="w-5 h-5 text-pitahaya" data-id="element-14" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-15">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-16">
            <div className="px-6 pb-4 text-gray-600 leading-relaxed" data-id="element-17">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}